const podcastPaymentStatus = Object.freeze({
  pending: 'Waiting Payment',
  accepted: 'Paid',
  rejected: 'Payment Rejected',
});

export default podcastPaymentStatus;
